import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, MenuItem, TextField } from "@mui/material";
import { LayoutCrearDoc } from "../../layouts";
import { useProveedorXID } from "../../../hooks/cache";
import { BotonesAndCargando } from "../../components/botones";
import { startSavingProveedor } from "../../../services";



import Swal from "sweetalert2";
import { mediosPago } from "../../../data";
const initUser = {
    banco: '',
    ciudad: "", 
    direccion: "", 
    formaPago: "", 
    movil: "", 
    nit: "", 
    nombre: "", 
    numeroCuenta: '',  
    observacion: "", 
    tipo: "", 
    tipoCuenta: '',  
};



export const CrearProveedores = () => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { data } = useProveedorXID(id);
    const [cargando, setCargando] = useState(false);
    const [formUsuario, setFormUsuario] = useState(initUser);
    const { nombre, nit, ciudad, direccion, movil, formaPago, observacion, tipo, numeroCuenta, tipoCuenta, banco } = formUsuario;

    

    useEffect(() => {
        if(data){
            setFormUsuario({ ...data, numeroCuenta: data.numeroCuenta || '' });
        }
    }, [data])
    


    const handleInputChange = ({ target }) => {
        setFormUsuario({
            ...formUsuario,
            [target.name]: target.value
        });
    }
        
    
    const handleCrearProveedor = async (e) => {
        e.preventDefault();
        const { isConfirmed } = await Swal.fire({
            title: data ? 'Editar Proveedor' : 'Crear Proveedor',
            text: data
            ? '¿Está seguro de editar este proveedor?'
            : '¿Está seguro de crear este proveedor?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: data ? 'Sí, Editar' : 'Sí, Crear',
            cancelButtonText: 'Cancelar'
        });

        if( !isConfirmed ) return;

        const resp = await startSavingProveedor({ ...formUsuario, id })
        if( resp && id === 'new' ) {
            setFormUsuario(initUser)
        }
    }




    return (


        <LayoutCrearDoc titulo={data ? 'Editar Proveedor' : 'Crear Proveedor'} funcion={ undefined } add={false}>
            <form className="formulario-total mt-5" o onSubmit={ handleCrearProveedor }>
                <Grid container spacing={4} sx={{mt:1}}>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant='outlined'
                            label='Nombre Usuario'
                            type='text'
                            placeholder='Nombre Usuario'
                            fullWidth
                            name="nombre"
                            value={ nombre }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant='outlined'
                            label='Nit'
                            type='text'
                            placeholder='Nit'
                            fullWidth
                            name="nit"
                            value={ nit }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            variant='outlined'
                            label='Tipo'
                            type='text'
                            placeholder='Tipo'
                            fullWidth
                            name="tipo"
                            value={ tipo }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant='outlined'
                            label='Ciudad'
                            type='text'
                            placeholder='Ciudad'
                            fullWidth
                            name="ciudad"
                            value={ ciudad }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            variant='outlined'
                            label='Dirección'
                            type='text'
                            placeholder='Dirección'
                            fullWidth
                            name="direccion"
                            value={ direccion }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            variant='outlined'
                            label='Movil'
                            type='number'
                            placeholder='Movil'
                            fullWidth
                            name="movil"
                            value={ movil }
                            onChange={ handleInputChange }  
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            required
                            variant='outlined'
                            select
                            label='Forma de Pago'
                            type='text'
                            placeholder='Forma de Pago'
                            fullWidth
                            name="formaPago"
                            value={ formaPago }
                            onChange={ handleInputChange } 
                        > 
                            <MenuItem value='CONTADO'>CONTADO</MenuItem>
                            <MenuItem value='CREDITO'>CREDITO</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant='outlined'
                            label='Observación'
                            type='text'
                            placeholder='Observación'
                            fullWidth
                            name="observacion"
                            value={ observacion }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            required
                            variant='outlined'
                            select
                            label="Seleccione Banco"
                            fullWidth
                            name="banco"
                            value={ banco }
                            onChange={ handleInputChange } 
                        >
                            <MenuItem value=''>Seleccione Banco</MenuItem>
                            {mediosPago.map(item => (
                                <MenuItem key={item} value={item}>{ item }</MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            required
                            variant='outlined'
                            select
                            label="Tipo de Cuenta"
                            fullWidth
                            name="tipoCuenta"
                            value={ tipoCuenta }
                            onChange={ handleInputChange } 
                        >
                            <MenuItem value="">Seleccione Cuenta</MenuItem>
                            <MenuItem value="Ahorros">Ahorros</MenuItem>
                            <MenuItem value="Corriente">Corriente</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant='outlined'
                            label='Numero Cuenta'
                            type='number'
                            placeholder='Numero Cuenta'
                            fullWidth
                            name="numeroCuenta"
                            value={ numeroCuenta }
                            onChange={ handleInputChange } 
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{mb:2, mt:5, display:'flex', justifyContent:'center' }}>
                    <Grid item xs={12} sm={6} md={5}>
                        <BotonesAndCargando
                            cargando={cargando}
                            titulo={(id === 'new') ? 'Crear' : 'Editar'} Proveedor
                            titulo2="Loading..."
                            icon1="save"
                            icon2="save"
                            esSubmit
                        />
                    </Grid>
                </Grid>

            </form>
        </LayoutCrearDoc>
    )
}
